export const environment = {
  production: true,

  // API via Traefik
  base_url: window.location.origin,

  // WebSocket via Traefik
  wsUrl:
    (window.location.protocol === 'https:' ? 'wss://' : 'ws://') +
    window.location.host +
    '/ws-chat',

  warning_icon: 'fa fa-exclamation-triangle',
  error_icon: 'fa fa-times-circle',
  info_icon: 'fa fa-exclamation-circle',

  info_message_type: 'Information',
  warning_message_type: 'Warning',
  error_message_type: 'Demande erronée',
};
/*
const isLocalhost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

export const environment = {
  production: !isLocalhost,

  base_url: isLocalhost
    ? 'http://localhost:8081'
    : window.location.origin,

  wsUrl: isLocalhost
    ? 'ws://localhost:8081/ws-notifications'
    : (
        (window.location.protocol === 'https:' ? 'wss://' : 'ws://') +
        window.location.host +
        '/ws-notifications'
      ),

  warning_icon: 'fa fa-exclamation-triangle',
  error_icon: 'fa fa-times-circle',
  info_icon: 'fa fa-exclamation-circle',

  info_message_type: 'Information',
  warning_message_type: 'Warning',
  error_message_type: 'Demande erronée',
};*/